import { z } from "zod";
import * as ShortMonth from "./short-month.js";
import * as TwoDigitYear from "./two-digit-year.js";
const shortMonthYYRegex = /^(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)\d{2}$/;
export const isShortMonthYY = (val) => shortMonthYYRegex.test(val);
/**
 * Throws if not ShortMonthYY
 */
export const assertAs = (val) => {
    if (isShortMonthYY(val)) {
        return val;
    }
    throw new Error(`${val} isn't ShortMonthYY`);
};
export const fromShortMonthAndYear = (shortMonth, year) => `${shortMonth}${year}`;
export const fromDayjs = (date) => fromShortMonthAndYear(ShortMonth.fromDayjs(date), TwoDigitYear.fromDayjs(date));
export const fromDate = (date) => fromShortMonthAndYear(ShortMonth.fromDate(date), TwoDigitYear.fromDate(date));
export const fromUTCDate = (date) => fromShortMonthAndYear(ShortMonth.fromUTCDate(date), TwoDigitYear.fromUTCDate(date));
export const fromISODateString = (val) => fromShortMonthAndYear(ShortMonth.fromISODateString(val), TwoDigitYear.fromISODateString(val));
export const fromMonthCodeYY = (monthCode) => fromShortMonthAndYear(ShortMonth.fromMonthCodeYY(monthCode), TwoDigitYear.fromMonthCodeYY(monthCode));
const CiShortMonthYYRegex = new RegExp(shortMonthYYRegex, "i");
export const CiShortMonthYYBrand = z
    .stringFormat("CaseInsensitiveShortMonthYY", (val) => CiShortMonthYYRegex.test(val))
    .brand();
export const fromCiShortMonthYY = (val) => fromShortMonthAndYear(ShortMonth.fromCiShortMonthYY(val), TwoDigitYear.fromShortMonthYY(val));
// use regex directly, as it's LOADs faster than going through zod's schema
export const isCiShortMonthYY = (val) => CiShortMonthYYRegex.test(val);
//# sourceMappingURL=short-month-yy.js.map